/**
 * Event Popup Component
 *
 * Extends Modal to provide event-specific popup functionality
 */

import { Modal } from 'theme';

class EventPopup extends Modal {
  connectedCallback() {
    super.connectedCallback();

    if (this.shouldAppearAutomatically) {
      setTimeout(() => this.show(), this.apparitionDelay);
    }
  }

  get apparitionDelay() {
    return parseInt(this.getAttribute('apparition-delay') || 0) * 1000;
  }

  get shouldAppendToBody() {
    return false;
  }

  get shouldAppearAutomatically() {
    return !(
      localStorage.getItem('theme:event-popup-filled') === 'true' ||
      (this.hasAttribute('only-once') && localStorage.getItem('theme:event-popup-appeared') === 'true')
    );
  }

  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);

    if (name === 'open' && this.open) {
      localStorage.setItem('theme:event-popup-appeared', 'true');
    }
  }
}

// Register custom element
if (!window.customElements.get('event-popup')) {
  window.customElements.define('event-popup', EventPopup);
}

export { EventPopup };
